import { FC } from 'react';
import { Modal, Table } from 'react-bootstrap';

interface UserTableModalProps {
    user: any;
    onClose: () => void;
    show: boolean;
}
const formatDateForInput = (timestamp: number) => {
    if (!timestamp || isNaN(timestamp)) return '';
    try {
        const date = new Date(timestamp);
        if (isNaN(date.getTime())) return '';

        const month = date.getMonth() + 1; // No padding with zeros
        const day = date.getDate(); // No padding with zeros
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    } catch {
        return '';
    }
};

export const ReconcillationGRNINFOPopUp: FC<UserTableModalProps> = ({ user, onClose, show }) => {
    return (
        <Modal
            className='modal fade'
            id='kt_modal_view_user'
            data-backdrop='static'
            tabIndex={-1}
            role='dialog'
            show={show}
            centered
            size="lg"
        >
            <div className="modal-content">
                <div className="modal-header pb-0 border-0 justify-content-end">
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={onClose}> X
                    </div>
                </div>

                <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
                    <div className="text-center mb-13">
                        <h1 className="mb-3">GRN Information</h1>
                    </div>

                    {/* Table 1: Supplied WT, Received WT, Gain/Loss */}
                    <div className="mb-10">
                        <h3 className="mb-5">Weight </h3>
                        <Table bordered hover>
                            <thead style={{ backgroundColor: '#BFD7ED' }}>
                                <tr>
                                    <th>Supplied WT</th>
                                    <th>Received WT</th>
                                    <th>Gain/Loss</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{user?.grnDetails?.totalQuantity || 'N/A'} Kg</td>
                                    <td>{user?.grnDetails?.recQuantity || 'N/A'} Kg</td>
                                    <td>{user?.grnDetails?.weightMeasurementType || 'N/A'}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>

                    {/* Table 2: Instruction, Amount, Document */}
                    <div className="mb-10">
                        <h3 className="mb-5">Instruction Details</h3>
                        <Table bordered hover>
                            <thead style={{ backgroundColor: '#BFD7ED' }}>
                                <tr>
                                    <th>Instruction</th>
                                    <th>Amount</th>
                                    <th>Document</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{user?.grnDetails?.note?.[0]?.noteType || 'N/A'}</td>
                                    <td>{user?.grnDetails?.note?.[0]?.price || 'N/A'} INR</td>
                                    <td>
                                        {user?.grnDetails?.note?.[0]?.images?.map((pdfUrl: string, index: number) => (
                                            <i
                                                key={index}
                                                className="bi bi-file-pdf text-danger cursor-pointer"
                                                style={{ fontSize: '3rem' }}
                                                onClick={() => window.open(pdfUrl, '_blank')}
                                                title="View PDF"
                                            ></i>
                                        )) || 'N/A'}
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>

                    {/* Table 3: Quality Assessment */}
                    <div className="mb-10">
                        {/* <h3 className="mb-5">Quality Assessment</h3> */}
                        <Table bordered hover>
                            <thead style={{ backgroundColor: '#BFD7ED' }}>
                                <tr>
                                    <th>Quality Remarks</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{user?.grnDetails?.qualityRemarks?.[0] || 'N/A'}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>

                    {/* Table 4: QA Images */}
                    <div className="mb-10">
                        <h3 className="mb-5">QA Images</h3>
                        <div className="flex flex-wrap">
                            {user && user.grnDetails && user.grnDetails.grnImages && Array.isArray(user.grnDetails.grnImages) ? (
                                user.grnDetails.grnImages
                                    .filter(doc => doc.docType === "QA_IMAGE")
                                    .map((doc, index) => (
                                        <div key={index} className="m-2">
                                            {doc.isPdf ? (
                                                <i
                                                    key={index}
                                                    className="bi bi-file-pdf text-red-500 cursor-pointer"
                                                    style={{ fontSize: '3rem' }}
                                                    onClick={() => window.open(doc.docUrl, '_blank')}
                                                    title="View PDF"
                                                ></i>
                                            ) : (
                                                <img
                                                    src={doc.docUrl}
                                                    alt={`QA Document ${index + 1}`}
                                                    className="max-w-xs max-h-xs object-contain border border-gray-200 rounded"
                                                />
                                            )}
                                        </div>
                                    ))
                            ) : (
                                <div className="p-4 text-gray-500">No QA documents available</div>
                            )}
                        </div>
                    </div>

                    {/* GRN Date */}
                    <div className="mb-10">
                        <h3 className="mb-5">GRN Date</h3>
                        <p>{formatDateForInput(user?.createdAt) || 'N/A'}</p>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={onClose}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};